//Libs
import React, { Component } from 'react';
import { Subscribe } from 'unstated'

//Componentes
import Loading from '../../Loading'
import ModalBase from '../../ModalBase';
import AcompanhamentoShared from '../../shared/acompanhamento/Acompanhamento';
import VisualizarCorrecao from '../../aluno/questoes/VisualizarCorrecao'
import TabelaAtividades from './TabelaAtividades';
import CollapsablePanel from '../../CollapsablePanel';
import FiltroGeral from './filtros/FiltroGeral';
import TabelaAlunos from './TabelaAlunos';
//import SelecionarEscola from '../SelecionarEscola';
//import SelecionarSerieAno from '../SelecionarSerieAno';
//import SimplePopover from '../../SimplePopover';

//Outros
import UserContainer from '../../../containers/user.container'
import { PracticeTestContainer } from '../../../containers/practiceTest.container'
import * as AcompanhamentoRequest from '../../../requests/acompanhamento.request';
import { TIPO_ACOMPANHAMENTO } from '../../../const';
import * as SimuladoRequest from '../../../requests/simulado.request';

class Acompanhamento extends Component {

    isUnmounted = false
    conteudoModalAluno = null

    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            loadingGeral: false,
            showingByIcons: true,
            loadingAcompanhamento: false,
            existSimulado: false,
            loadedDadosAcompanhamento: 0,
            mediaComponenteCurricular: 0,
            mediaTRI: 0,
            mediaTRIEscola: 0,
            notasTRI: [],
            mediasDisciplina: [],
            mediashabilidade: [],
            listaAlunos: [],
            listaAtividades: [],
            loadingStudentData: false,
            showUserModal: false,
            filtros: {}
        };


        //this.onChangeSerieAno = this.onChangeSerieAno.bind(this);
        //this.onChangeSelectedSchool = this.onChangeSelectedSchool.bind(this)
        //this.onClickViewByList = this.onClickViewByList.bind(this)
        //this.onClickViewByIcon = this.onClickViewByIcon.bind(this)
        //this.onDesempenhoAlunoSelecionado = this.onDesempenhoAlunoSelecionado.bind(this)
        //this.onDetalhesAlunoSelecionado = this.onDetalhesAlunoSelecionado.bind(this)
        //this.onGabaritoAlunoSelecionado = this.onGabaritoAlunoSelecionado.bind(this)
        this.onClickAtividadeSimulado = this.onClickAtividadeSimulado.bind(this)
        this.closeModalAluno = this.closeModalAluno.bind(this)
        this.onClickAplicarFiltros = this.onClickAplicarFiltros.bind(this)
        this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this)
    }

    async componentDidMount() {
        await this.props.userContainer.getSchools()
        // await this.props.userContainer.getSegmentGrades()
        // if (this.props.userContainer.state.classes.length > 0 && this.props.userContainer.hasGradeSelected()) {
        //     //Exibindo o loading
        //     this.setState({ loadingAcompanhamento: true });

        //     // atualiza a situação dos simulados dos alunos
        //     await SimuladoRequest.setSituacaoSimuladoSerie(this.props.userContainer.state.selectedGrade.idGrade);

        //     // atualiza a nota TRI dos alunos
        //     await SimuladoRequest.setNotasTriSerie(this.props.userContainer.state.selectedGrade.idGrade);

        //     //Buscando as médias de Notas TRI
        //     var notasTRI = await AcompanhamentoRequest.getNotasTRISerie(this.props.userContainer.state.selectedGrade.idGrade);
        //     // console.log(mediasDisciplina)

        //     //Buscando as médias por disciplina
        //     var mediasDisciplina = await AcompanhamentoRequest.getMediasDisciplinaSerie(this.props.userContainer.state.selectedGrade.idGrade);
        //     // console.log(mediasDisciplina)

        //     //Buscando as médias por habilidade
        //     var mediasHabilidade = await AcompanhamentoRequest.getMediasHabilidadeSerie(this.props.userContainer.state.selectedGrade.idGrade);
        //     // console.log(mediasDisciplina)

        //     // Obtendo a lista de alunos
        //     var listaAlunos = await AcompanhamentoRequest.getListaAlunosSerie(this.props.userContainer.state.selectedGrade.idGrade);
        //     console.log('LISTA', listaAlunos);

        //     //Se não tem informação, exibe o emptyState
        //     if (!notasTRI || notasTRI.length === 0 || !mediasDisciplina || mediasDisciplina.length === 0 || !mediasHabilidade || mediasHabilidade.length === 0 || !listaAlunos || listaAlunos.length === 0) {
        //         this.setState({ loadingAcompanhamento: false, loadedDadosAcompanhamento: -1 });
        //         return;
        //     }

        //     //Define os estados das médias
        //     this.setState({ notasTRI: notasTRI, mediaTRIEscola: this.getMediaTRIEscola(notasTRI), mediasDisciplina: mediasDisciplina, mediaComponenteCurricular: this.getMediaDisciplina(mediasDisciplina), mediasHabilidade: mediasHabilidade, listaAlunos: listaAlunos, loadedDadosAcompanhamento: 1 });

        //     //Esconde o loading
        //     this.setState({ loadingAcompanhamento: false });
        // }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
        this.isUnmounted = true
    }

    handleWindowSizeChange() {
        this.setState({ width: window.innerWidth });
    }

    // onChangeSelectedSchool(school) {
    //     this.props.userContainer.setState({ selectedSchool: school, selectedGrade: {}, classes: [] })
    //     this.props.practiceTestContainer.setInitialState(school);
    // }

    // async onChangeSerieAno(grade) {
    //     this.setState({ loadingGeral: true })
    //     //user container
    //     let selectedSchool = this.props.userContainer.state.selectedSchool;
    //     if (!selectedSchool) {
    //         selectedSchool = this.props.userContainer.state.schools[0];
    //     }

    //     //Buscando se existe simulado realizado para o aluno
    //     var existSimulado = await SimuladoRequest.getStatusSimuladoSerie(grade.idGrade);

    //     //Define se existe simulado e finaliza o loading
    //     this.setState({ existSimulado: existSimulado, loadingGeral: false })

    //     await this.props.userContainer.setState({ selectedSchool: selectedSchool, selectedGrade: grade, classes: [] }, async () => {
    //         if (existSimulado) {
    //             //Exibindo o loading
    //             this.setState({ loadingAcompanhamento: true });

    //             //Buscando as médias de Notas TRI
    //             var notasTRI = await AcompanhamentoRequest.getNotasTRISerie(this.props.userContainer.state.selectedGrade.idGrade);

    //             //Buscando as médias por disciplina
    //             var mediasDisciplina = await AcompanhamentoRequest.getMediasDisciplinaSerie(this.props.userContainer.state.selectedGrade.idGrade);
    //             // console.log(mediasDisciplina)

    //             //Buscando as médias por habilidade
    //             var mediasHabilidade = await AcompanhamentoRequest.getMediasHabilidadeSerie(this.props.userContainer.state.selectedGrade.idGrade);
    //             // console.log(mediasHabilidade)

    //             // Obtendo a lista de alunos
    //             var listaAlunos = await AcompanhamentoRequest.getListaAlunosSerie(this.props.userContainer.state.selectedGrade.idGrade);
    //             console.log(listaAlunos);

    //             //Se não tem informação, exibe o emptyState
    //             if (!mediasDisciplina || mediasDisciplina.length === 0 || !mediasHabilidade || mediasHabilidade.length === 0 || !listaAlunos || listaAlunos.length === 0) {
    //                 this.setState({ loadingAcompanhamento: false, loadedDadosAcompanhamento: -1 });
    //                 return;
    //             }

    //             //Define os estados das médias
    //             this.setState({ notasTRI: notasTRI, mediaTRIEscola: this.getMediaTRIEscola(notasTRI), mediasDisciplina: mediasDisciplina, mediaComponenteCurricular: this.getMediaDisciplina(mediasDisciplina), mediasHabilidade: mediasHabilidade, listaAlunos: listaAlunos, loadedDadosAcompanhamento: 1 });

    //             //Esconde o loading
    //             this.setState({ loadingAcompanhamento: false });
    //         }
    //     });
    // }

    // onClickViewByList() {
    //     if (this.state.showingByIcons) this.setState({ showingByIcons: false });
    // }

    // onClickViewByIcon() {
    //     if (!this.state.showingByIcons) this.setState({ showingByIcons: true });
    // }

    getMediaTRI(medias) {
        return (medias.reduce((partial_sum, a) => (partial_sum + a.nuScoreTRI), 0) / medias.length).toFixed(2);
    }

    getMediaDisciplina(medias) {
        return Math.trunc((medias || []).reduce((total, soma, index, array) => {
            total += soma.pcCorrectSchool;
            if (index === array.length - 1) {
                return total / array.length;
            } else {
                return total;
            }
        }, 0));
    }

    getMediaTRIEscola(medias) {
        return (medias.reduce((partial_sum, a) => (partial_sum + a.nuScoreTRISchool), 0) / medias.length).toFixed(2);
    }

    //async onGabaritoAlunoSelecionado(idStudent, idExam) {
    //     this.setState({ showUserModal: true })
    //     this.conteudoModalAluno = <VisualizarCorrecao idExam={idExam} idStudent={idStudent} />
    // }


        async onClickAtividadeSimulado(idExam) {
            this.setState({ showUserModal: true })
            this.conteudoModalAluno = <VisualizarCorrecao idExam={idExam} idStudent={this.state.filtros.alunoSelecionado} />
        }

    // async onDesempenhoAlunoSelecionado(idStudent) {
    //     this.setState({ showUserModal: true, loadingStudentData: true })
    //     console.log('usr: ', idStudent)

    //     var results = await Promise.all([
    //         //Buscando as médias por disciplina
    //         AcompanhamentoRequest.getMediasDisciplina(idStudent),
    //         //Buscando as médias por habilidade
    //         AcompanhamentoRequest.getMediasHabilidade(idStudent),
    //         //Buscando as médias por disciplina
    //         AcompanhamentoRequest.getNotasTRI(idStudent)
    //     ])

    //     var mediasDisciplina = results[0]
    //     var mediasHabilidade = results[1]
    //     var notasTRI = results[2]

    //     var data = {
    //         notasTRI: notasTRI,
    //         mediaTRI: this.getMediaTRI(notasTRI),
    //         mediaTRIEscola: this.getMediaTRIEscola(notasTRI),
    //         mediasDisciplina: mediasDisciplina,
    //         mediaComponenteCurricular: this.getMediaDisciplina(mediasDisciplina),
    //         mediasHabilidade: mediasHabilidade
    //     }

    //     this.conteudoModalAluno = <AcompanhamentoShared {...data} />

    //     this.setState({ loadingStudentData: false })
    // }

    // async onDetalhesAlunoSelecionado(idStudent, idExam) {
    //     this.setState({ showUserModal: true, loadingStudentData: true })
    //     const listaDetalhes = await AcompanhamentoRequest.getListaDeAtividadesPorAlunoESimulado(idStudent, idExam)
    //     // console.log('listaDetalhes', listaDetalhes)

    //     this.conteudoModalAluno = <TabelaAtividades listaAtividades={listaDetalhes} />

    //     this.setState({ loadingStudentData: false })
    // }

    // getValorEngajamentoAluno(engajamento) {
    //     if (engajamento && engajamento.length) {
    //         const e = engajamento[0]
    //         return Math.trunc(((e.simuladosFinalizados + e.estudosConcluidos) / (e.totalSimulados + e.estudosAlocados) * 100)) + "%"
    //     }
    //     return '-'
    // }

    closeModalAluno() {
        this.conteudoModalAluno = null
        this.setState({ showUserModal: false, loadingStudentData: false })
    }

    async onClickAplicarFiltros(filtros) {
        // console.log("Filtros", filtros);
        this.setState({ filtros: filtros });

        if (filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.GRAFICO && filtros.serieSelecionada) {
            this.setState({ loadingGeral: true });

            // atualiza a situação dos simulados dos alunos
            await SimuladoRequest.setSituacaoSimuladoSerie(filtros.serieSelecionada);
            // atualiza a nota TRI dos alunos
            await SimuladoRequest.setNotasTriSerie(filtros.serieSelecionada);

            this.popularGrafico(
                filtros.serieSelecionada,
                filtros.periodoSelecionado,
                filtros.simuladoSelecionado,
                filtros.turmasSelecionadas,
                filtros.alunoSelecionado);
        }
        else if (filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ALUNOS && filtros.serieSelecionada) {
            this.setState({ loadingGeral: true });

            // atualiza a situação dos simulados dos alunos
            await SimuladoRequest.setSituacaoSimuladoSerie(filtros.serieSelecionada);
            // atualiza a nota TRI dos alunos
            await SimuladoRequest.setNotasTriSerie(filtros.serieSelecionada);

            this.popularListaAlunos(
                filtros.serieSelecionada,
                filtros.periodoSelecionado,
                filtros.simuladoSelecionado,
                filtros.turmasSelecionadas);
        }
        else if (filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ATIVIDADES && filtros.alunoSelecionado) {
            this.setState({ loadingGeral: true });

            // atualiza a situação dos simulados dos alunos
            await SimuladoRequest.setSituacaoSimuladoSerie(filtros.serieSelecionada);
            // atualiza a nota TRI dos alunos
            await SimuladoRequest.setNotasTriSerie(filtros.serieSelecionada);

            //TODO: descobrir como obter o parametro idExam
            this.popularListaAtividades(
                filtros.alunoSelecionado,
                filtros.periodoSelecionado,
                filtros.simuladoSelecionado
                );
        }
    }

    async popularListaAtividades(idStudent, nuPeriod, idPracticeTestType) {

        var listaAtividades = await AcompanhamentoRequest.getListaAtividadesAluno(nuPeriod, idPracticeTestType, idStudent);

        this.setState({ loadingGeral: false, listaAtividades: listaAtividades || [] });
    }

    async popularListaAlunos(serie, nuPeriod, idPracticeTestType, lstIdClass) {

        var listaAlunos = await AcompanhamentoRequest.getListaAlunosSerie(serie,nuPeriod, idPracticeTestType, lstIdClass);

        this.setState({ loadingGeral: false, listaAlunos: listaAlunos || [] });
    }

    async popularGrafico(serie, nuPeriod, idPracticeTestType, lstIdClass, idStudent) {
        var notasTRI = []
        var mediasDisciplina = [];
        var mediasHabilidade = [];
        if(idStudent){

            //Buscando as médias de Notas TRI
            notasTRI = await AcompanhamentoRequest.getNotasTRI(idStudent, nuPeriod, idPracticeTestType);

            //Buscando as médias por disciplina
            mediasDisciplina = await AcompanhamentoRequest.getMediasDisciplina(idStudent, nuPeriod, idPracticeTestType);

            //Buscando as médias por habilidade
            mediasHabilidade = await AcompanhamentoRequest.getMediasHabilidade(idStudent, nuPeriod, idPracticeTestType);
        }
        else
        {
            //Buscando as médias de Notas TRI
            notasTRI = await AcompanhamentoRequest.getNotasTRISerie(serie, nuPeriod, idPracticeTestType, lstIdClass);

            //Buscando as médias por disciplina
            mediasDisciplina = await AcompanhamentoRequest.getMediasDisciplinaSerie(serie, nuPeriod, idPracticeTestType, lstIdClass);

            //Buscando as médias por habilidade
            mediasHabilidade = await AcompanhamentoRequest.getMediasHabilidadeSerie(serie, nuPeriod, idPracticeTestType, lstIdClass);
        }

        //Se não tem informação, exibe o emptyState
        if (!mediasDisciplina || mediasDisciplina.length === 0 || !mediasHabilidade || mediasHabilidade.length === 0) {
            this.setState({ loadingGeral: false, loadedDadosAcompanhamento: -1 });
            return;
        }

        //Esconde o loading e Define os estados das médias
        this.setState({
            loadingGeral: false,
            notasTRI: notasTRI,
            mediaTRI: this.getMediaTRI(notasTRI),
            mediaTRIEscola: this.getMediaTRIEscola(notasTRI),
            mediasDisciplina: mediasDisciplina,
            mediaComponenteCurricular: this.getMediaDisciplina(mediasDisciplina),
            mediasHabilidade: mediasHabilidade,
            loadedDadosAcompanhamento: 1
        });
    }

    render() {
        const isMobile = this.state.width <= 768;
        console.log('this.state.notasTRI', this.state.notasTRI)

        return (
            <div className="">

                <CollapsablePanel
                    openText="Filtro"
                    closeText="Filtro"
                    isCollapsed={isMobile}
                    panelContent={<FiltroGeral isMobile={isMobile} selected={this.state.filtros} onClickAplicar={this.onClickAplicarFiltros} />}
                    mainContent={<div className="edb-padding-left edb-margin-top edb-padding-top">

                        {this.state.loadingGeral && <Loading />}

                        {/******** EmptyState nenhum filtro marcado ********/}
                        {this.state.filtros.tipoAcompSelecionado === undefined && <div className="edb-padding">

                            <div className="edb-row edb-hide-small">
                                <h3 className="edb-text-bold">Bem vindo ao painel de acompanhamento</h3>
                                <p>Utilize o <strong>filtro</strong> para acompanhar as informações sobre o andamento da sua escola, seus alunos, suas atividades, etc.</p>
                            </div>
                            <div className="edb-row edb-hide-medium edb-hide-large">
                                <div className="edb-col edb-center">

                                    <h3 className="edb-text-bold">Bem vindo ao painel de acompanhamento</h3>
                                    <p>Aqui você poderá acompanhar informações sobre o andamento da sua escola, seus alunos, suas atividades, etc.</p>
                                    <p style={{ maxWidth: '200px', display: 'inline-block' }}>
                                        Selecione no <strong>filtro</strong> as informações que deseja visualizar.
                                    </p>
                                </div>
                            </div>
                        </div>}

                        {/******** EmptyState gráfico (Selecionar série) ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.GRAFICO
                            && !this.state.filtros.serieSelecionada
                            && <div className="edb-margin-top">
                                <div className="edb-center edb-margin-large-top">
                                    <h3 className="edb-text-bold">Acompanhamento por gráficos</h3>
                                    <p>Para visualizar o gráfico você precisa escolher no <strong>filtro</strong> uma série.</p>
                                    <p>Se preferir, você pode escolher também turmas e alunos.</p>
                                </div>
                            </div>}

                        {/******** EmptyState gráfico (Nenhuma informação) ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.GRAFICO
                            && this.state.filtros.serieSelecionada
                            && !this.state.loadingGeral
                            && this.state.loadedDadosAcompanhamento === -1
                            && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">
                                <h4>Ainda não há informações suficientes para gerar o gráfico.</h4>
                                <p>Verifique em Simulados se há agendamento e se algum aluno já finalizou.</p>
                            </div>}

                        {/******** Gráfico ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.GRAFICO
                            && this.state.filtros.serieSelecionada
                            && !this.state.loadingGeral
                            && this.state.loadedDadosAcompanhamento === 1
                            && <div className="edb-margin-top">
                                <div className="edb-large edb-text-bold edb-margin-large-bottom">
                                    {this.state.filtros.descricaoAluno && <span><span className="edb-text-bolder">{this.state.filtros.descricaoAluno}</span><span> | </span></span>}
                                    <span>{this.state.filtros.descricaoPeriodoSimulado}</span>
                                    <span> | </span>
                                    <span>{this.state.filtros.descricaoSerieTurma}</span>
                                </div>
                                <AcompanhamentoShared
                                    grade={this.state.filtros.alunoSelecionado?null:this.state.filtros.serieSelecionada}
                                    mediaTRI={this.state.mediaTRI}
                                    mediaTRIEscola={this.state.mediaTRIEscola}
                                    notasTRI={this.state.notasTRI}
                                    mediasDisciplina={this.state.mediasDisciplina}
                                    mediaComponenteCurricular={this.state.mediaComponenteCurricular}
                                    mediasHabilidade={this.state.mediasHabilidade}
                                />
                            </div>}


                        {/******** EmptyState Lista de alunos (Selecionar série) ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ALUNOS
                            && !this.state.filtros.serieSelecionada
                            && <div className="edb-margin-top">
                                <div className="edb-center edb-margin-large-top">
                                    <h3 className="edb-text-bold">Lista de alunos</h3>
                                    <p>Para visualizar a lista de alunos você precisa escolher no <strong>filtro</strong> uma série.</p>
                                    <p>Se preferir, você pode escolher também as turmas.</p>
                                </div>
                            </div>}

                        {/******** Lista de alunos ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ALUNOS
                            && this.state.filtros.serieSelecionada
                            && !this.state.loadingGeral
                            && <div className="edb-margin-top">
                                <h3 className="edb-text-bolder">Lista de alunos</h3>
                                <div className="edb-text-bold">
                                    {this.state.filtros.descricaoAluno && <span><span className="edb-text-bolder">{this.state.filtros.descricaoAluno}</span><span> | </span></span>}
                                    <span>{this.state.filtros.descricaoPeriodoSimulado}</span>
                                    <span> | </span>
                                    <span>{this.state.filtros.descricaoSerieTurma}</span>
                                </div>
                                <TabelaAlunos fileName={(this.state.filtros.descricaoAluno?this.state.filtros.descricaoAluno+"_":"")+this.state.filtros.descricaoPeriodoSimulado + " - " + this.state.filtros.descricaoSerieTurma} listaAlunos={this.state.listaAlunos} />
                            </div>}


                        {/******** EmptyState Lista de atividades (Selecionar aluno) ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ATIVIDADES
                            && !this.state.filtros.alunoSelecionado
                            && <div className="edb-margin-top">
                                <div className="edb-center edb-margin-large-top">
                                    <h3 className="edb-text-bolder">Lista de atividades</h3>
                                    <p>Para visualizar a lista de atividades você precisa escolher no <strong>filtro</strong> um aluno.</p>
                                </div>
                            </div>}

                        {/******** Lista de atividades ********/}
                        {this.state.filtros.tipoAcompSelecionado === TIPO_ACOMPANHAMENTO.LISTA_ATIVIDADES
                            && this.state.filtros.alunoSelecionado
                            && !this.state.loadingGeral
                            && <div className="edb-margin-top">
                                <h3 className="edb-text-bolder">Lista de atividades</h3>
                                <div className="edb-text-bold">
                                    {this.state.filtros.descricaoAluno && <span><span className="edb-large">{this.state.filtros.descricaoAluno}</span><span> | </span></span>}
                                    <span>{this.state.filtros.descricaoPeriodoSimulado}</span>
                                    <span> | </span>
                                    <span>{this.state.filtros.descricaoSerieTurma}</span>
                                </div>
                                <TabelaAtividades fileName={(this.state.filtros.descricaoAluno?this.state.filtros.descricaoAluno+"_":"")+this.state.filtros.descricaoPeriodoSimulado + " - " + this.state.filtros.descricaoSerieTurma} listaAtividades={this.state.listaAtividades} onClickSimulado={this.onClickAtividadeSimulado} />
                            </div>}
                    </div>}
                />


{this.state.showUserModal &&
    <ModalBase
        loading={this.state.loadingStudentData}
        isOpen={this.state.showUserModal}
        onCloseModal={this.closeModalAluno}
        content={<div className="edb-padding" style={{overflowX: "scroll", width: "100%", maxWidth: "900px"}}>
            {this.conteudoModalAluno}
        </div>}
    />
}
  {/*
                       <div className="edb-row">
                            <div className="edb-col l8 edb-margin-bottom ">
                                <SelecionarEscola
                                    escolas={this.props.userContainer.state.schools}
                                    onChange={this.onChangeSelectedSchool}
                                />
                            </div>
                        </div>

                        {this.props.userContainer.state.loadingSegmentGrades && <Loading />}

                        {!this.props.userContainer.state.loadingSegmentGrades && <span>
                            <SelecionarSerieAno
                                className="edb-margin-top"

                                turmas={this.props.userContainer.state.classes}
                                segmentoSeries={this.props.userContainer.state.segmentGrades}
                                serieSelecionada={this.props.userContainer.state.selectedGrade}

                                // onChangeTags={this.onChangeTagsSerieAno}
                                onChangeSerie={this.onChangeSerieAno}
                            />
                            {this.state.loadingGeral && <Loading />}

                            {!this.state.loadingGeral && !this.props.userContainer.hasGradeSelected() && <span>Selecione uma série para continuar</span>}
                            {!this.state.loadingGeral && this.props.userContainer.hasGradeSelected() && !this.state.existSimulado && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">
                                <h4>Não há simulados finalizados ainda para esta série!</h4>
                                <p>Verifique em Simulados se há agendamento e se algum aluno já finalizou.</p>
                            </div>}
                            {!this.state.loadingGeral && this.props.userContainer.hasGradeSelected() && this.state.existSimulado && this.state.loadingAcompanhamento && <Loading />}
                            {this.state.loadedDadosAcompanhamento === -1 && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">
                                <h4>Não foi possível carregar os dados de acompanhamento!</h4>
                                <p>Tente novamente mais tarde.</p>
                            </div>}
                            {this.state.loadedDadosAcompanhamento === 1 && !this.state.loadingGeral && this.props.userContainer.hasGradeSelected() && this.state.existSimulado && !this.state.loadingAcompanhamento && <span>
                                <div className="edb-row edb-margin-large-bottom">
                                    <SimplePopover noPadding={true} displayRight={true} rightAlign={true} content={<div className="edb-bar-block" style={{ right: 0 }}>
                                        <button className="edb-bar-item edb-button edb-medium" onClick={this.onClickViewByList}>Ver por lista</button>
                                        <button className="edb-bar-item edb-button edb-medium" onClick={this.onClickViewByIcon}>Ver por gráficos</button>
                                    </div>}>

                                        <i className="fas fa-ellipsis-h edb-margin-left"></i>
                                    </SimplePopover>
                                </div>
                                {this.state.showingByIcons &&
                                    <AcompanhamentoShared
                                        grade={this.props.userContainer.state.selectedGrade.idGrade}
                                        mediaTRIEscola={this.state.mediaTRIEscola}
                                        notasTRI={this.state.notasTRI}
                                        mediasDisciplina={this.state.mediasDisciplina}
                                        mediaComponenteCurricular={this.state.mediaComponenteCurricular}
                                        mediasHabilidade={this.state.mediasHabilidade}
                                    />}
                                {!this.state.showingByIcons && <div>
                                    <div className="edb-row">
                                        <h3 className="edb-text-bolder">Alunos da série</h3>
                                        <table className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                                            <thead className="edb-hide-small">
                                                <tr>
                                                    <th className="">Aluno</th>
                                                    <th className="">Turma</th>
                                                    <th className="">Situação</th>
                                                    <th className="">Data de realização</th>
                                                    <th className="">Nota TRI</th>
                                                    <th className="">Ações</th>
                                                    <th className="">Engajamento</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.listaAlunos.map((item, index) => (<tr key={'realizacoes_' + index}>
                                                    <td className="">{item.txScreenName}</td>
                                                    <td className="">{item.txClass}</td>
                                                    <td className="">{item.txExamTakenStatus}</td>
                                                    <td className="">{this.formatDateTime(item.dtStart)}</td>
                                                    <td className="">{item.nuScoreTRI || '-'}</td>
                                                    <td className="" >
                                                        <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onDesempenhoAlunoSelecionado(item.idUser)}>Desempenho</span>
                                                        <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onGabaritoAlunoSelecionado(item.idUser, item.idExam)}>Gabarito</span>
                                                        <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onDetalhesAlunoSelecionado(item.idUser, item.idExam)}>Detalhes</span>
                                                    </td>
                                                    <td className="">{this.getValorEngajamentoAluno(item.engajamento)}</td>
                                                </tr>)
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>}
                            </span>}
                        </span>} */}

            </div>
        );
    }
}

// higher order component
export default () => (<Subscribe to={[UserContainer, PracticeTestContainer]}>
    {(user, simulado) => <Acompanhamento userContainer={user} practiceTestContainer={simulado} />}
</Subscribe>);
// export default Acompanhamento;
